import * as React from 'react';

import { Layout, Row, Col } from 'antd';

import './bv-login-template.scss';

import loginTemplateBG from '../../../assets/images/bv-login-template-bg.jpg';

const {
    Content
} = Layout;

const BVLoginTemplate: React.FunctionComponent = (props) => (
    <Layout className={'bv-login-template'}>
        <Content>
            <Row style={{ height: '100%' }}>
                <Col span={16}>
                    <div className="template-bg" style={{ backgroundImage: `url('${loginTemplateBG}')` }}></div>
                </Col>
                <Col span={8}>
                    {props.children}
                </Col>
            </Row>
        </Content>
    </Layout>
);

export default BVLoginTemplate;